module.exports = __webpack_public_path__ + "static/img/zzLogo.c0c59442.png";